import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MobileApp from './MobileApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isMobile = window.innerWidth <= 768;

root.render(
    isMobile ? <MobileApp /> : <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
